function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, memo, useCallback } from 'react';
import { isVideo } from '../../utils/media';
import ImageDisplay from '../ImageDisplay/ImageDisplay';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { isShortFormVideo } from './utils/mediaFilter';
import { MediaGrid, MediaItem, RemoveButton, ShortFormBadge, OverflowIndicator, VideoGradientOverlay, VideoPlayButton, FullscreenToggle, DurationBadge } from './styles/index';
/**
 * 미디어 그리드 뷰 컴포넌트
 * 이미지와 비디오를 그리드 형태로 표시합니다.
 */ var MediaGridView = function(param) {
    var media = param.media, displayableMedia = param.displayableMedia, hoveredIndex = param.hoveredIndex, setHoveredIndex = param.setHoveredIndex, getGridClass = param.getGridClass, getItemClass = param.getItemClass, handleMediaClick = param.handleMediaClick, onRemove = param.onRemove, _param_isSubmitting = param.isSubmitting, isSubmitting = _param_isSubmitting === void 0 ? false : _param_isSubmitting;
    // 현재 재생 중인 비디오 상태 관리
    var _useState = _sliced_to_array(useState(null), 2), playingIndex = _useState[0], setPlayingIndex = _useState[1];
    // 오류 발생 시 콘솔에 로깅 (useCallback 사용 및 index를 선택적으로 받도록 수정)
    var handleMediaError = useCallback(function(error, index) {
        // index가 없을 경우를 대비한 로그 메시지 조정 (선택적)
        var logIndex = index !== undefined ? index : 'unknown';
        console.error("Media at index ".concat(logIndex, " failed to load"), index !== undefined ? media[index] : undefined, error);
    }, [
        media
    ]); // media 배열에 의존
    // 비디오 재생 핸들러
    var handlePlayVideo = function(e, index) {
        e.stopPropagation(); // 상위 컴포넌트로 이벤트 전파 방지
        setPlayingIndex(index === playingIndex ? null : index); // 토글 재생/정지
    };
    // 전체화면으로 보기 핸들러
    var handleExpandMedia = function(e, item, index) {
        e.stopPropagation(); // 상위 컴포넌트로 이벤트 전파 방지
        handleMediaClick(item, index); // 기존 모달 열기 핸들러 호출
    };
    var gridClass = getGridClass();
    return /*#__PURE__*/ React.createElement(MediaGrid, {
        layoutClass: gridClass
    }, displayableMedia.map(function(item, index) {
        var isVideoMedia = item.type === 'video' || !item.type && isVideo(item.url);
        var isHovered = hoveredIndex === index;
        var isPlaying = playingIndex === index;
        var itemClass = getItemClass(item, index);
        return /*#__PURE__*/ React.createElement(MediaItem, {
            key: item.id || "media-item-".concat(index),
            itemClass: itemClass,
            isHovered: isHovered,
            isVideo: isVideoMedia,
            onMouseEnter: function() {
                return setHoveredIndex(index);
            },
            onMouseLeave: function() {
                return setHoveredIndex(null);
            },
            onClick: function(e) {
                return isVideoMedia ? handlePlayVideo(e, index) : handleExpandMedia(e, item, index);
            }
        }, isVideoMedia && !isPlaying && /*#__PURE__*/ React.createElement(VideoGradientOverlay, null), isVideoMedia ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(VideoPlayer, {
            width: "100%",
            height: "100%",
            controls: isPlaying,
            muted: !isPlaying,
            loop: true,
            autoPlay: isPlaying,
            fileBlob: item.file,
            mediaIndex: index,
            onError: handleMediaError
        }), !isPlaying && /*#__PURE__*/ React.createElement(VideoPlayButton, {
            type: "button",
            isHovered: isHovered,
            onClick: function(e) {
                return handlePlayVideo(e, index);
            },
            "aria-label": "비디오 재생"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "22",
            height: "22",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }, /*#__PURE__*/ React.createElement("polygon", {
            points: "6 4 20 12 6 20 6 4"
        }))), /*#__PURE__*/ React.createElement(FullscreenToggle, {
            type: "button",
            isVisible: isHovered || isPlaying,
            onClick: function(e) {
                return handleExpandMedia(e, item, index);
            },
            "aria-label": "전체 화면으로 보기"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
        }))), !isPlaying && /*#__PURE__*/ React.createElement(DurationBadge, null, "0:30")) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ImageDisplay, {
            src: item.url || '_placeholder_',
            alt: "미디어 ".concat(index + 1),
            imageBlob: item.file,
            fallbackSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII="
        }), /*#__PURE__*/ React.createElement(FullscreenToggle, {
            type: "button",
            isVisible: isHovered,
            onClick: function(e) {
                return handleExpandMedia(e, item, index);
            },
            "aria-label": "전체 화면으로 보기"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
        })))), onRemove && !isSubmitting && /*#__PURE__*/ React.createElement(RemoveButton, {
            type: "button",
            isHovered: isHovered,
            onClick: function(e) {
                e.stopPropagation();
                onRemove(media.indexOf(item));
            },
            "data-testid": "tweet-media-remove-button",
            "aria-label": "미디어 삭제"
        }, /*#__PURE__*/ React.createElement("svg", {
            width: "12",
            height: "12",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3,
            d: "M6 18L18 6M6 6l12 12"
        }))), isVideoMedia && isShortFormVideo(item) && /*#__PURE__*/ React.createElement(ShortFormBadge, null, "숏폼"), index === 3 && media.length > 4 && /*#__PURE__*/ React.createElement(OverflowIndicator, null, /*#__PURE__*/ React.createElement("span", null, "+", media.length - 4)));
    }));
};
// 컴포넌트를 memo로 감싸서 export
export default /*#__PURE__*/ memo(MediaGridView);
